import React,{useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import BrandServices from '../../services/BrandServices';
function AddBrand() {
const navigate = useNavigate();
  
  const [formValues, setFormValues] = useState({
    name: '',
    type: '',
    image: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path



  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
//   // Handle form submission
const handleSubmit = async (event) => {
  event.preventDefault();
  try {
    const formData = new FormData();
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    await BrandServices.createBrand(formData);
    alert('Brand created successfully');
    navigate('/brand');
    
  } catch (error) {
    console.error('Failed to create Brand', error);
    alert('Failed to create Brand');
  }
};

  return (
    <>
    <div className="right_col" role="main">
        <div className="title-box">
          <h2>Brand Add</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/brand"> Brand List</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-6">
                <div className="input-field">
                  <label>Select your Vehicle Type <span className="red">*</span></label>
                  <select className="form-control" value={formValues.type} 
                        onChange={handleInputChange} name="type">
                          <option value= "">--Select Type--</option>
                        <option value="Car">Car</option>
                        <option value="Bike or 3-Wheeler">Bike or 3-Wheeler</option>
                      </select>
                </div>
                </div>
            
                <div className="col-md-6">
                <div className="input-field">
                  <label>Select your Brand<span className="red">*</span></label>               
                  <input type="text" name="name" value={formValues.name} 
                        onChange={handleInputChange} placeholder="Brand Name" className="form-control"  />
                </div>
                </div>
    
                <div className="col-md-6">
                <div className="input-field">
                  <label>Brand Logo<span className="red">*</span></label>
                  <input type="file" name="image" className="form-control" onChange={handleFileChange}/>
                  <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>
                </div>
                </div>
                </div>
                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddBrand